import { Box, Dialog, DialogContent, Typography, alpha } from '@mui/material';
import React, { ReactNode } from 'react';
import headerCloudSmall from '../assets/header-cloud-small.svg';
import headerSiteSmall from '../assets/header-site-small.svg';
import LoadingIndicator from '../loading-indicator/LoadingIndicator';
import { ExerciseType, SimulatorType } from '../types';
import { getKSim } from '../utils/ksim';

export interface SimulationLoadingDialogProps {
  children?: ReactNode;
  exerciseType: ExerciseType;
  message: string;
  onClose?: () => void;
  open?: boolean;
  progress: number; // [0-100]
  simulatorType: SimulatorType;
}

const SimulationLoadingDialog = ({
  children,
  exerciseType,
  message,
  onClose,
  open = false,
  progress,
  simulatorType,
}: SimulationLoadingDialogProps) => {
  const ksim = getKSim(exerciseType, simulatorType);

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 4 } }}>
      <DialogContent
        sx={{
          backgroundColor: `${simulatorType === SimulatorType.Cloud ? alpha('#5A6EDD', 0.3) : '#C8E6C9'}`,
          backgroundImage: `url(${simulatorType === SimulatorType.Cloud ? headerCloudSmall : headerSiteSmall})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center 90px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: '33px',
        }}
      >
        <Box display="grid" sx={{ placeContent: 'center', width: '128px', height: '128px' }}>
          <Box component={LoadingIndicator} progress={progress / 100} sx={{ position: 'absolute' }} />
          <Typography component="span" color="primary.contrastText" variant="h4" position="relative">
            {progress}%
          </Typography>
        </Box>
        <Box component="img" src={ksim} height={119} alt="K-Sim" mt="32px" mb="54px" />
        <Typography
          variant="h5"
          textAlign="center"
          mb="40px"
          sx={{
            height: '2lh',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
          }}
        >
          {message}
        </Typography>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default SimulationLoadingDialog;
